import React from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
    const { user, logout } = useAuth();

    const handleLogout = async () => {
        await logout();
    };

    return (
        <Navbar bg="primary" variant="dark" expand="lg" className="py-2">
            <Container fluid>
                <Navbar.Brand as={Link} to="/dashboard" className="p-0">
                    <img src="/cropped-logo.jpg" alt="Echo Fire and Medical logo"/>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        {user && (
                            <NavDropdown
                                title={`${user.firstName} ${user.lastName}`}
                                id="user-dropdown"
                                align="end"
                            >
                                <NavDropdown.Item as={Link} to="/profile">
                                    <i className="bi bi-person me-2"></i>
                                    Profile
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/admin" >
                                        <i className="bi bi-gear me-2"></i>
                                        Admin
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={handleLogout}>
                                    Logout
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;